export const savePl = (value) => ({
    type: "SAVE_PLAYLIST",
    value: value
})